import { Box, EmptyState, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC } from 'react';

import { HelpCenterError } from '../../types';
import {
  helpCenterErrorToImage,
  helpCenterErrorToPrefixMap,
} from './constants';
import s from './styles.scss';

interface ErrorTemplateParams {
  errorName: HelpCenterError;
}

export const ErrorTemplate: FC<ErrorTemplateParams> = ({ errorName }) => {
  const { t } = useTranslation();
  const image = helpCenterErrorToImage[errorName];
  const prefix = helpCenterErrorToPrefixMap[errorName];

  return (
    <Box direction="vertical" padding="42px">
      <EmptyState
        align="center"
        image={image}
        title={
          <Text
            dataHook="error-template_title"
            weight="bold"
            className={s.title}
            tagName="p"
          >
            {t(`${prefix}_title`)}
          </Text>
        }
        subtitle={
          <Text
            dataHook="error-template_subtitle"
            className={s.subtitle}
            tagName="p"
          >
            {t(`${prefix}_subtitle`)}
          </Text>
        }
        dataHook={`error-template_${errorName}`}
      ></EmptyState>
    </Box>
  );
};
